// legacy function from santa:
// https://github.com/wix-private/santa-core/blob/master/santa-core-utils/src/coreUtils/core/guidUtils.js#L160
// https://github.com/wix-private/santa-core/blob/master/santa-core-utils/src/coreUtils/core/hashUtils.js
const sha256_K = [
	1116352408,
	1899447441,
	-1245643825,
	-373957723,
	961987163,
	1508970993,
	-1841331548,
	-1424204075,
	-670586216,
	310598401,
	607225278,
	1426881987,
	1925078388,
	-2132889090,
	-1680079193,
	-1046744716,
	-459576895,
	-272742522,
	264347078,
	604807628,
	770255983,
	1249150122,
	1555081692,
	1996064986,
	-1740746414,
	-1473132947,
	-1341970488,
	-1084653625,
	-958395405,
	-710438585,
	113926993,
	338241895,
	666307205,
	773529912,
	1294757372,
	1396182291,
	1695183700,
	1986661051,
	-2117940946,
	-1838011259,
	-1564481375,
	-1474664885,
	-1035236496,
	-949202525,
	-778901479,
	-694614492,
	-200395387,
	275423344,
	430227734,
	506948616,
	659060556,
	883997877,
	958139571,
	1322822218,
	1537002063,
	1747873779,
	1955562222,
	2024104815,
	-2067236844,
	-1933114872,
	-1866530822,
	-1538233109,
	-1090935817,
	-965641998,
]
const GUID_FORMAT = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
const sha256_S = (X: number, n: number) => (X >>> n) | (X << (32 - n))
const sha256_R = (X: number, n: number) => X >>> n
const sha256_Ch = (x: number, y: number, z: number) => (x & y) ^ (~x & z)
const sha256_Maj = (x: number, y: number, z: number) => (x & y) ^ (x & z) ^ (y & z)
const sha256_Sigma0256 = (x: number) => sha256_S(x, 2) ^ sha256_S(x, 13) ^ sha256_S(x, 22)
const sha256_Sigma1256 = (x: number) => sha256_S(x, 6) ^ sha256_S(x, 11) ^ sha256_S(x, 25)
const sha256_Gamma0256 = (x: number) => sha256_S(x, 7) ^ sha256_S(x, 18) ^ sha256_R(x, 3)
const sha256_Gamma1256 = (x: number) => sha256_S(x, 17) ^ sha256_S(x, 19) ^ sha256_R(x, 10)

const safe_add = (x: number, y: number) => {
	const lsw = (x & 0xffff) + (y & 0xffff)
	const msw = (x >> 16) + (y >> 16) + (lsw >> 16)
	return (msw << 16) | (lsw & 0xffff)
}

const binb_sha256 = (m: Array<number>, l: number) => {
	const HASH = [1779033703, -1150833019, 1013904242, -1521486534, 1359893119, -1694144372, 528734635, 1541459225]
	const W: Array<number> = []
	let a, b, c, d, e, f, g, h
	let i, j, T1, T2

	m[l >> 5] |= 0x80 << (24 - (l % 32))
	m[(((l + 64) >> 9) << 4) + 15] = l

	for (i = 0; i < m.length; i += 16) {
		a = HASH[0]
		b = HASH[1]
		c = HASH[2]
		d = HASH[3]
		e = HASH[4]
		f = HASH[5]
		g = HASH[6]
		h = HASH[7]

		for (j = 0; j < 64; j++) {
			if (j < 16) {
				W[j] = m[j + i]
			} else {
				W[j] = safe_add(
					safe_add(safe_add(sha256_Gamma1256(W[j - 2]), W[j - 7]), sha256_Gamma0256(W[j - 15])),
					W[j - 16]
				)
			}

			T1 = safe_add(safe_add(safe_add(safe_add(h, sha256_Sigma1256(e)), sha256_Ch(e, f, g)), sha256_K[j]), W[j])
			T2 = safe_add(sha256_Sigma0256(a), sha256_Maj(a, b, c))
			h = g
			g = f
			f = e
			e = safe_add(d, T1)
			d = c
			c = b
			b = a
			a = safe_add(T1, T2)
		}

		HASH[0] = safe_add(a, HASH[0])
		HASH[1] = safe_add(b, HASH[1])
		HASH[2] = safe_add(c, HASH[2])
		HASH[3] = safe_add(d, HASH[3])
		HASH[4] = safe_add(e, HASH[4])
		HASH[5] = safe_add(f, HASH[5])
		HASH[6] = safe_add(g, HASH[6])
		HASH[7] = safe_add(h, HASH[7])
	}
	return HASH
}

const str2rstr_utf8 = (input: string) => {
	let output = ''
	let i = -1
	let x, y

	while (++i < input.length) {
		x = input.charCodeAt(i)
		y = i + 1 < input.length ? input.charCodeAt(i + 1) : 0
		if (x >= 0xd800 && x <= 0xdbff && y >= 0xdc00 && y <= 0xdfff) {
			x = 0x10000 + ((x & 0x03ff) << 10) + (y & 0x03ff)
			i++
		}

		if (x <= 0x7f) {
			output += String.fromCharCode(x)
		} else if (x <= 0x7ff) {
			output += String.fromCharCode(0xc0 | ((x >>> 6) & 0x1f), 0x80 | (x & 0x3f))
		} else if (x <= 0xffff) {
			output += String.fromCharCode(0xe0 | ((x >>> 12) & 0x0f), 0x80 | ((x >>> 6) & 0x3f), 0x80 | (x & 0x3f))
		} else if (x <= 0x1fffff) {
			output += String.fromCharCode(
				0xf0 | ((x >>> 18) & 0x07),
				0x80 | ((x >>> 12) & 0x3f),
				0x80 | ((x >>> 6) & 0x3f),
				0x80 | (x & 0x3f)
			)
		}
	}
	return output
}

const rstr2binb = (input: string) => {
	const output = []
	const length = input.length >> 2
	for (let i = 0; i < length; i++) {
		output[i] = 0
	}
	for (let ii = 0; ii < input.length * 8; ii += 8) {
		output[ii >> 5] |= (input.charCodeAt(ii / 8) & 0xff) << (24 - (ii % 32))
	}
	return output
}

const binb2rstr = (input: Array<number>) => {
	let output = ''
	for (let i = 0; i < input.length * 32; i += 8) {
		output += String.fromCharCode((input[i >> 5] >>> (24 - (i % 32))) & 0xff)
	}
	return output
}

const rstr_sha256 = (s: string) => {
	return binb2rstr(binb_sha256(rstr2binb(s), s.length * 8))
}

const rstr2hex = (input: string) => {
	const hex_tab = '0123456789abcdef'
	let output = ''
	let x
	for (let i = 0; i < input.length; i++) {
		x = input.charCodeAt(i)
		output += hex_tab.charAt((x >>> 4) & 0x0f) + hex_tab.charAt(x & 0x0f)
	}
	return output
}

const hex_sha256 = (s: string) => {
	return rstr2hex(rstr_sha256(str2rstr_utf8(s)))
}

export const nameUUIDFromString = (str: string) => {
	if (!str) {
		return ''
	}
	const digest = hex_sha256(str)
	return GUID_FORMAT.replace(/[xy]/g, (match, offset) =>
		match === 'x' ? digest[offset] : '89ab'[parseInt(digest[30], 16) % 4]
	)
}
